module.exports = __webpack_public_path__ + "img/icon_empty.60962d09.png";